import client from "../client";

export interface GetUdiamondAllResponse {
  ID?: number;
  AmountUdiamond?: number;
  AmountCredit?: number;
  CreateAt?: Date;
  UpdateAt?: Date;
}

export default function API(): Promise<GetUdiamondAllResponse[]> {
  return client
    .get(`genaral/get_udiamond_all`)
    .then((response) => response.data);
}
